import React from 'react';
import classnames from 'classnames';

// Styles
import './WpDrawerV2Footer.scss';

type Props = {
  children?: React.ReactNode;
  justifyContent?: 'flexStart' | 'flexEnd' | 'spaceBetween' | 'center';
};

const WpDrawerV2Footer = ({ children, justifyContent = 'flexStart' }: Props) => {
  const baseClassName = 'WpDrawerV2Footer';
  const classes = classnames(baseClassName, `${baseClassName}--${justifyContent}`);

  return <div className={classes}>{children}</div>;
};

export default WpDrawerV2Footer;
